import { useState } from "react";
import { Staff } from "../../features/services/staff/Staff.type";
import { deleteStaff } from "../../features/services/staff/StaffService";
import {
  validateStaffField,
  validateStaffForm,
} from "../../features/services/staff/StaffValidation";

const useStaffForm = (initialStaff: Staff) => {
  const [errors, setErrors] = useState({});
  const [currentStaff, setCurrentStaff] = useState<Staff>(initialStaff);

  const handleSave = (saveCallback: any) => {
    const { valid, errors } = validateStaffForm(currentStaff);
    if (valid) {
      saveCallback(currentStaff);
    } else {
      setErrors(errors);
    }
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    const { valid, error } = validateStaffField(name, value);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: valid ? "" : error,
    }));

    setCurrentStaff((prevStaff: Staff) => ({
      ...prevStaff,
      [name]: value,
    }));
  };

  const handleRowClick = (row: any) => {
    setCurrentStaff(row);
    setErrors({});
  };

  const handleDelete = async (staffId: number, onDelete: () => void) => {
    try {
      await deleteStaff(staffId);
      onDelete();
    } catch (error) {
      console.error("Failed to delete staff:", error);
    }
  };

  return {
    currentStaff,
    setCurrentStaff,
    handleSave,
    handleDelete,
    handleRowClick,
    handleInputChange,
    errors,
    setErrors,
  };
};

export default useStaffForm;
